/**
 * Re-open Shopify cookie consent banner from footer/privacy links.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a[href="#cookie-preferences"]');
  if (!trigger) return;

  event.preventDefault();

  const openBanner = () => {
    if (typeof window.Shopify?.customerPrivacy?.showBanner === 'function') {
      window.Shopify.customerPrivacy.showBanner();
      return true;
    }
    return false;
  };

  if (openBanner()) return;

  window.Shopify?.loadFeatures?.(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    () => openBanner()
  );
});
